
import { VendorDetailConstant } from "./VendorDetailConstant";


const VendorDetailActions = {};

VendorDetailActions.getVendorDetail = (payload) => {

  return {
    type: VendorDetailConstant.VENDOR_DETAIL_SAGA,
     payload: payload,
  };
};

VendorDetailActions.getVendorOverView = () => {
  return {
    type: VendorDetailConstant.VENDOR_OVERVIEW_SAGA,
  };
};

VendorDetailActions.chargingEnableDisable = ({id, status}) => {
  return {
    type: VendorDetailConstant.CHARGING_ENABLE_DISABLE_SAGA,
    payload: {id, status},
  };
}

VendorDetailActions.chargingPointEnableDisable = ({id, status}) => {
  return {
    type: VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_SAGA,
    payload: {id, status},
  };
}
VendorDetailActions.chargingPointDelete = (id) => {
  return {
    type: VendorDetailConstant.CHARGING_POINT_DELETE_SAGA,
    payload: id,
  };
}






VendorDetailActions.getRequestViewDetailsVendorAction = (id) => {

    return {
        type: VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_SAGA,id
        
    }
};

export { VendorDetailActions };
